import React, {FunctionComponent} from "react";
import {PropsWithOverwrite} from "../../../utils/input";
import Input, {InputProps} from "./Input";
import clsx from "clsx";

export type InputRadioProps = Omit<PropsWithOverwrite<InputProps<string | number>, {
    value: string | number;
    checked: boolean;
}>, "type">;

const InputRadio: FunctionComponent<InputRadioProps> = ({cssClass, ...inputAttr}) => {
    return (
        <Input
            type="radio"
            cssClass={clsx("input-radio", cssClass)}
            {...inputAttr}
        />
    );
};

export default InputRadio;
